module.exports = __webpack_public_path__ + "media/images/lit parapluie-1d1a4cbc4ed9aa8f7f7d90e0c9cb4743.svg";